import {
  FlagOutlined,
  LinkOutlined,
  TableOutlined,
  FilePptOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import {
  Permission,
  Resource,
  UserType,
} from "components/CurrentUser/constants";
import BlankLayout from "layouts/BlankLayout";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/get-link",
    name: "get_link.title",
    icon: FlagOutlined,
    component: BlankLayout,
    permissions: [
      [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
      [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
      [Resource.CAMPAIGN_PARTNER, Permission.CREATE],
      [Resource.CAMPAIGN_PARTNER, Permission.FULL_CREATE],
    ],
    routes: [
      {
        path: "/get-link/build-link",
        name: "get_link.build_link.title",
        icon: LinkOutlined,
        component: lazy(() => import("./pages/BuildLink")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
          [Resource.CAMPAIGN_PARTNER, Permission.CREATE],
          [Resource.CAMPAIGN_PARTNER, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/get-link/build-link/program/:id",
        name: "get_link.build_link.title",
        component: lazy(
          () => import("./pages/BuildLink/pages/BuildLinkWithProgram")
        ),
        searchable: false,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/get-link/program/:id",
        name: "get_link.brand.title",
        component: lazy(() => import("./pages/Program/pages/ProgramDetail")),
        searchable: true,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/get-link/brand",
        name: "get_link.brand.title",
        icon: TableOutlined,
        component: lazy(() => import("./pages/Brand")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
        permissionUser: [
          UserType.KOL,
          UserType.OPERATOR,
          UserType.PARTNER,
          UserType.SELLER,
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/get-link/brand/:id",
        name: "get_link.brand.title",
        component: lazy(() => import("./pages/Brand/pages/BrandDetail")),
        searchable: true,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/get-link/product",
        name: "get_link.product.title",
        icon: FilePptOutlined,
        component: lazy(() => import("./pages/Product")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
        permissionUser: [
          UserType.KOL,
          UserType.OPERATOR,
          UserType.PARTNER,
          UserType.SELLER,
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/get-link/product/:id",
        name: "get_link.product.title",
        component: lazy(() => import("./pages/Product/pages/ProductDetail")),
        searchable: true,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/get-link/seller",
        name: "get_link.seller.title",
        icon: CreditCardOutlined,
        component: lazy(() => import("./pages/Seller")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
        permissionUser: [
          UserType.KOL,
          UserType.OPERATOR,
          UserType.PARTNER,
          UserType.SELLER,
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/get-link/seller/:id",
        name: "get_link.seller.title",
        component: lazy(() => import("./pages/Seller/pages/SellerDetail")),
        searchable: true,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "*",
        component: lazy(() => import("components/base/Errors/NotFound")),
        hideInMenu: true,
      },
    ],
  },
];

export default routes;
